import { createApp, nextTick } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vClickOutside from 'click-outside-vue3';
import BootstrapVue3 from 'bootstrap-vue-3';
import VueCookies from 'vue3-cookies';
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/aura-light-green/theme.css';
import '@fortawesome/fontawesome-free/js/all.js';
import helpers from '@/utils/helpers';
import { attachGlobal } from '@/utils/enter-nav';

import AnsInput from '@/components/ansInput';
import AnsDatePicker from '@/components/ansDatePicker';
import AnsMultiDatePicker from '@/components/ansMultiDatePicker';
import AnsSelect from '@/components/ansSelect';
import AnsMultiSelect from '@/components/ansMultiSelect';
import AnsCheckbox from '@/components/ansCheckbox';
import AnsRadioButton from '@/components/ansRadioButton';
import AnsFile from '@/components/ansFile';
import AnsSwitch from '@/components/ansSwitch';
import AnsButton from '@/components/ansButton';
import AnsInputSearch from '@/components/ansInputSearch';
import AnsList from '@/components/ansList';
import AnsTable from '@/components/ansTable';
import AnsPanelHeader from '@/components/ansPanelHeader';
import AnsPanel from '@/components/ansPanel';
import AnsPostCode from '@/components/ansPostCode';
import AnsDatalist from '@/components/ansDatalist';
import AnsPagination from '@/components/ansPagination';
import AnsPhoneFax from '@/components/ansPhoneFax';
import AnsDateTime from '@/components/ansDateTime';
import AnsTooltipSpan from '@/components/ansTooltipSpan';
import PtjAnsInput from '@/components/ptjAnsInput';
import PtjAnsButton from '@/components/ptjAnsButton';
import PtjAnsPagination from '@/components/ptjAnsPagination';
import PtjAnsSelect from '@/components/ptjAnsSelect';
import PtjAnsInputSearch from '@/components/ptjAnsInputSearch';
import PtjRadioButton from '@/components/ptjRadioButton';
import PtjSwitch from '@/components/ptjSwitch';
import AnsSelectSearch from '@/components/ansSelectSearch/index.vue';

const app = createApp(App);
app.use(vClickOutside);
app.use(BootstrapVue3);
app.use(VueCookies, {
    expireTimes: '30d',
    path: '/'
});
app.use(store);
app.use(router);
app.use(PrimeVue);

app.component('AnsInput', AnsInput);
app.component('AnsDatePicker', AnsDatePicker);
app.component('AnsMultiDatePicker', AnsMultiDatePicker);
app.component('AnsSelect', AnsSelect);
app.component('AnsSelectSearch', AnsSelectSearch);
app.component('AnsMultiSelect', AnsMultiSelect);
app.component('AnsCheckbox', AnsCheckbox);
app.component('AnsRadioButton', AnsRadioButton);
app.component('AnsFile', AnsFile);
app.component('AnsSwitch', AnsSwitch);
app.component('AnsButton', AnsButton);
app.component('AnsInputSearch', AnsInputSearch);
app.component('AnsList', AnsList);
app.component('AnsTable', AnsTable);
app.component('AnsPanelHeader', AnsPanelHeader);
app.component('AnsPanel', AnsPanel);
app.component('AnsPostCode', AnsPostCode);
app.component('AnsDatalist', AnsDatalist);
app.component('AnsPagination', AnsPagination);
app.component('AnsPhoneFax', AnsPhoneFax);
app.component('AnsDateTime', AnsDateTime);
app.component('AnsTooltipSpan', AnsTooltipSpan);
app.component('PtjAnsInput', PtjAnsInput);
app.component('PtjAnsButton', PtjAnsButton);
app.component('PtjAnsPagination', PtjAnsPagination);
app.component('PtjAnsSelect', PtjAnsSelect);
app.component('PtjAnsInputSearch', PtjAnsInputSearch);
app.component('PtjRadioButton', PtjRadioButton);
app.component('PtjSwitch', PtjSwitch);

app.config.globalProperties.$helpers = helpers;

const setFavicon = () => {
    let icon = document.querySelector("link[rel~='icon']");
    if (!icon) {
        icon = document.createElement('link');
        icon.rel = 'icon';
        document.head.appendChild(icon);
    }

    const base = process.env.BASE_URL || '/';

    const faviconPath = window.location.href.includes('CUS_FAQ') ? `${base}GMLogo.ico` : `${base}move.ico`;

    if (icon.href !== faviconPath) {
        icon.href = faviconPath;
    }
};
setFavicon();
router.afterEach(() => {
    setFavicon();
});
app.mount('#app');
// Auto attach enter navigation globally
nextTick(() => {
    void attachGlobal({ loop: true, scopeSelector: '[data-enter-nav]' });
});
